import helperModule from '../helper.module';

class VarHelper {
    isInteger(value) {
        return (
            typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value
        );
    }
}

export default helperModule.service('varHelper', VarHelper);



// WEBPACK FOOTER //
// ./modules/helper/varHelper/varHelper.service.js